import React from 'react';
import { useState, useEffect, useRef } from 'react';
import '../assets/css/story.css';
import { Link } from 'react-router-dom';
import { TitleBar } from '../components/TitleBar'
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from "gsap/ScrollTrigger"

import { TopButton } from "../components/TopButton"
import { getStoryDatabase } from '../utils/notionClient';


export default function StoryPage() {
  const [storyData, setStoryData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStoryData = async () => {
      try {
        const data = await getStoryDatabase();
        setStoryData(data);
      } catch (error) {
        console.error('Failed to fetch story data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStoryData();
  }, []);

  useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `나눔소식 | 어르신본죽왔어요`;
  },[]);

  const [open, setOpen] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState({}); // 새 상태 추가

  const handleClickOpen = (story) => () => {
    setOpen(true);
    setDialogContent(story);
  };

  const handleClose = () => {
    setOpen(false);
  };


  gsap.registerPlugin(useGSAP, ScrollTrigger);
  const container = useRef();

  useGSAP(() => {
    let tl01 = gsap.timeline({
      default:{duration: 0.1},
    }); // 인트로

    tl01.from('.motiona1', { opacity: 0, y: 100, })
  }, { scope: container });

  return (
    <article ref={container}>
      <TitleBar />
      <TopButton />
      <section id='story-news' className='section inner motiona1'>
      
      {loading ? (
          <div>로딩 중...</div>
        ) : storyData && storyData.length > 0 ? (
          storyData.map((story) => (
            <button 
              key={story.postId} 
              className='story-slide' 
              onClick={handleClickOpen(story)}
            >
              <div className='thumb'>
                {story.img && <img src={story.img} alt={story.title || '이미지'} />}
              </div>
              <div className='title'>
                {story.type && <p>{story.type}</p>}
                {story.title && <h4>{story.title}</h4>}
              </div>
            </button>
          ))
        ) : (
          <div>데이터가 없습니다.</div>
        )}


          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className='story-dialog'
            scroll='paper'  // 추가: 'paper'로 설정
            PaperProps={{   // 추가: Dialog 전체 스타일 설정
              sx: {
                maxHeight: '90vh',
                overflowY: 'auto'
              }
            }}
            >

            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={(theme) => ({
                  position: 'absolute',
                  right: 8,
                  top: 8,
                  color: theme.palette.grey[500],
                  zIndex: 1
                })}
              >
              <CloseIcon />
            </IconButton>

            <div className='story-img'>
              <img src={process.env.PUBLIC_URL + dialogContent.img} alt={dialogContent.title} />
            </div>
            
            <DialogTitle id="alert-dialog-title">
               {dialogContent.title}
            </DialogTitle>
            

            <DialogContent sx={{ padding: '20px', overflowY: 'visible' }}>
              <DialogContentText id="alert-dialog-description">
                <p>{dialogContent.description}</p>
                <Link to={dialogContent.link} target="_blank">👉 링크 바로가기</Link>
              </DialogContentText>
            </DialogContent>

          </Dialog>


        </section>
    </article>
    
  );
};
  